export const weatherRasterTileConfigs = {
  soilMoisture: {
    id: "soil-moisture",
    type: "raster",
    isDynamic: true,
    sourceId: "soil-raster-source",
    layerId: "soil-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/soil-moisture/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },

    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.9,
      },
    },

    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/soil-moisture/raster/point`,
      label: "Humidité du sol",
      unit: "%",
    },
  },
  windGust: {
    id: "windGust",
    type: "raster",
    isDynamic: true,
    sourceId: "windGust-source",
    layerId: "windGust-layer",

    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/wind-gust/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },

    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.9,
      },
    },

    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/wind-gust/raster/point`,
      label: "Rafales de vent",
      unit: "km/h",
    },
  },
  windDirection: {
    id: "windDirection",
    type: "raster",
    isDynamic: true,
    sourceId: "windDirection-source",
    layerId: "windDirection-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/wind-direction/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 1,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/wind-direction/raster/point`,
      label: "Direction du vent",
      unit: "°",
    },
  },
  windSpeed: {
    id: "windSpeed",
    type: "raster",
    isDynamic: true,
    sourceId: "windSpeed-source",
    layerId: "windSpeed-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/wind-speed/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.9,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/wind-speed/raster/point`,
      label: "Vitesse du vent",
      unit: "Km/h",
    },
  },
  precipitations: {
    id: "precipitations",
    type: "raster",
    isDynamic: true,
    sourceId: "precipitations-source",
    layerId: "precipitations-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/total-percipitation/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.9,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/total-percipitation/raster/point`,
      label: "Précipitation totale",
      unit: "mm",
    },
  },
  hourlyPrecipitations: {
    id: "hourlyPrecipitations",
    type: "raster",
    isDynamic: true,
    sourceId: "hourly-precipitations-source",
    layerId: "hourly-precipitations-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/1h-percipitation/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.9,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/1h-percipitation/raster/point`,
      label: "Précipitations horaires cumulées",
      unit: "mm",
    },
  },
  temperature: {
    id: "temperature",
    type: "raster",
    isDynamic: true,
    sourceId: "temperature-source",
    layerId: "temperature-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/temperature/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.9,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/temperature/raster/point`,
      label: "Température",
      unit: "°C",
    },
  },
  relativeHumidity: {
    id: "relativeHumidity",
    type: "raster",
    isDynamic: true,
    sourceId: "relative-humidity-source",
    layerId: "relative-humidity-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/relative-humidity/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.9,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/relative-humidity/raster/point`,
      label: "Humidité relative",
      unit: "%",
    },
  },
  meanSeaLevelPressure: {
    id: "meanSeaLevelPressure",
    type: "raster",
    sourceId: "mean-sea-level-pressure-source",
    layerId: "mean-sea-level-pressure-layer",
    isDynamic: true,
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/pr2msl/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.9,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/pr2msl/raster/point`,
      label: "Pression au niveau de la mer",
      unit: "Pa",
    },
  },
  cloudCover: {
    id: "cloudCover",
    type: "raster",
    isDynamic: true,
    sourceId: "cloud-cover-source",
    layerId: "cloud-cover-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/cloud/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.9,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_WEATHER_BASEURL_V1}/cloud/raster/point`,
      label: "Couverture nuageuse",
      unit: "%",
      band: 1,
    },
  },
 
};
